export const DETAIL_PANEL_MIN_TABLE_VIEWPORT_PX = 440;
export const DETAIL_PANEL_MIN_TABLE_VIEWPORT_HEIGHT = `${DETAIL_PANEL_MIN_TABLE_VIEWPORT_PX}px`;

export const getDetailPanelTableSectionSx = (
  minHeight = DETAIL_PANEL_MIN_TABLE_VIEWPORT_HEIGHT
) => ({
  flex: '1 1 auto',
  minHeight,
  overflow: 'visible',
  display: 'flex',
  flexDirection: 'column',
});

export const getDetailPanelTableBodySx = (
  minHeight = DETAIL_PANEL_MIN_TABLE_VIEWPORT_HEIGHT
) => ({
  flex: 1,
  minHeight,
  display: 'flex',
  flexDirection: 'column',
});

export const buildOwnedMrtLayout = ({
  enableInternalScroll,
  minHeight = 0,
  internalTableContainerSx,
  internalTablePaperSx,
}) => {
  const toolbarProps = { sx: { flexShrink: 0 } };

  if (enableInternalScroll) {
    return {
      containerSx: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        height: '100%',
      },
      tableWrapperSx: {
        flex: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
      },
      muiTableContainerProps: { sx: internalTableContainerSx, tabIndex: 0 },
      muiTablePaperProps: { sx: internalTablePaperSx },
      muiTopToolbarProps: toolbarProps,
      muiBottomToolbarProps: toolbarProps,
    };
  }

  return {
    containerSx: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      flex: 1,
      minHeight: minHeight || 0,
    },
    tableWrapperSx: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      minHeight: minHeight || 0,
    },
    muiTableContainerProps: {
      tabIndex: 0,
      sx: {
        maxHeight: 'none',
        overflow: 'visible',
      },
    },
    muiTablePaperProps: {
      sx: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: minHeight || 0,
      },
    },
    muiTopToolbarProps: toolbarProps,
    muiBottomToolbarProps: toolbarProps,
  };
};
